import { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AuthServices from '../services/AuthServices';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [userrole, setUserrole] = useState("");
    const [token, setToken] = useState(localStorage.getItem('token') || null);
    const [loading, setLoading] = useState(true); // Add loading state

    const decodeTokenAndSetUser = (token) => {
        try {
            const decodedToken = JSON.parse(atob(token.split('.')[1]));
            const currentTime = Date.now() / 1000;
            console.log(decodedToken,"token--")
            if (decodedToken.exp < currentTime) {
                console.error("Token expired");
                logoutUser();
            } else {
                setUser(decodedToken.id);
                setUserrole(decodedToken.role);
            }
        } catch (error) {
            console.error("Failed to decode token:", error);
            logoutUser();
        } finally {
            setLoading(false); // Set loading to false after decoding
        }
    };

    useEffect(() => {
        if (token) {
            
            decodeTokenAndSetUser(token);
        } else {
            setLoading(false); // Set loading to false if no token exists
        }
    }, [token]);

    const loginUser = async (credentials) => {
        try {
            const data = await AuthServices.login(credentials);
            setToken(data.token);
            localStorage.setItem('token', data.token);
            setUserrole(data.role);
            localStorage.setItem('userrole', data.role);
            localStorage.setItem('user', JSON.stringify(data.user));
            decodeTokenAndSetUser(data.token);
            return data;
        } catch (error) {
            console.error("Login failed:", error);
            throw error;
        }
    };

    const logoutUser = () => {
        setToken(null);
        setUser(null);
        setUserrole("");
        localStorage.removeItem('token');
        localStorage.removeItem('userrole');
        localStorage.removeItem('isteacher');
        localStorage.removeItem('user');
    };

    const autoLoginUser = (token, role,user ) => {
        setToken(token);
        localStorage.setItem('token', token);
        setUserrole(role);
        localStorage.setItem('userrole', role);
        localStorage.setItem('user', JSON.stringify(user));
        decodeTokenAndSetUser(token);
        return true;
    };

    const registerUser = async (userdetails) => {
        const data = await AuthServices.register(userdetails);
        await autoLoginUser(data.token, data.role,data.user);
        return data;
    };

    const registerTeacher = async (userdetails) => {
        const data = await AuthServices.teacherregister(userdetails);
        await autoLoginUser(data.token, data.role,data.user);
        return data;
    };

    const registerSchool = async (userdetails) => {
        // await AuthServices.schoolregister(userdetails);
        const data = await AuthServices.schoolregister(userdetails);
         await autoLoginUser(data.token, data.role ,data.user);
         return data;
    };

    return (
        <AuthContext.Provider value={{ 
            user,
            token,
            userrole,
            loading, // Expose loading state
            loginUser,
            logoutUser,
            registerUser,
            registerTeacher,
            registerSchool
            
        }}>
            {children}
        </AuthContext.Provider>
    );
};

AuthProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default AuthContext;